'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./with-border.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function withBorder(Component) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var WithBorder = function WithBorder(_ref) {
    var className = _ref.className,
        _ref$border = _ref.border,
        border = _ref$border === undefined ? defaults.border : _ref$border,
        props = _objectWithoutProperties(_ref, ['className', 'border']);

    var classes = (0, _classnames2.default)('with-border', border && 'with-border--border-' + border, className);

    return _react2.default.createElement(Component, _extends({ className: classes }, props));
  };

  WithBorder.propTypes = _extends(Component.propTypes || {}, _extends({}, Component.propTypes, {
    border: _propTypes2.default.oneOf(['none'])
  }));

  WithBorder.defaultProps = _extends({}, Component.defaultProps);

  return WithBorder;
}

exports.default = withBorder;